import { render } from "./ProjectSummaryPlaceholder.vue?vue&type=template&id=ab26dd74"
import script from "./ProjectSummaryPlaceholder.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryPlaceholder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__